<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <transportation-options
          value="141"
          :allowed-transport-options="allowedTransportOptions"
          @onChange="onOptionChange"
        />
      </div>
      <div class="col-md-4">
        <ValidationProvider
          v-slot="{ errors }"
          name="Accompany"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedOptionAcompany"
            :options="companyList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Acompañante:'"
            :disabled="transportDisabled"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onCompanyChange"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-4">
        <ValidationProvider
          v-slot="{ errors }"
          name="SpecialEquipment"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedOptionSpecialEquipment"
            :options="specialEquipmentList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Equipo Especial:'"
            :placeholder="'Seleccione una opción'"
            :disabled="transportDisabled"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            @input="onSpecialEquipmentChange"
          />
        </ValidationProvider>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="Departure"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedOptionDeparture"
            :options="departureList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Partida:'"
            :disabled="transportDisabled || isEducationalService"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onDepartureChange"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DepartureDirection"
          rules="required"
        >
          <CustomInput
            v-model="model.departure.addressLine1"
            label="Dirección:"
            :disabled="transportDisabled || disabledDeparture"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <CustomInput
          v-model="model.departure.addressLine2"
          label="Dirección 2:"
          :disabled="transportDisabled || disabledDeparture"
        />
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DepartureMunicipality"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedDepartureMunicipality"
            :options="municipalityList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Municipio:'"
            :disabled="transportDisabled || disabledDeparture"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onDepartureMunicipalityChange"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-1 col-lg-1 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DepartureZipcode"
          rules="required"
        >
          <CustomInput
            v-model="model.departure.zipCode"
            label="Zipcode:"
            maxlength="5"
            mask-type="Zipcode"
            placeholder="#####"
            :disabled="transportDisabled || disabledDeparture"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-1 col-lg-1 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DepartureEstate"
          rules="required"
        >
          <CustomInput
            v-model="model.departure.state"
            label="Estado:"
            :disabled="transportDisabled || disabledDeparture"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DeparturePhone"
          rules="required"
        >
          <CustomInput
            v-model="model.departure.phone"
            label="Tel.:"
            :disabled="transportDisabled || disabledDeparture"
            :mask-type="'Phone'"
            placeholder="(787) ###-####"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
          />
        </ValidationProvider>
      </div>
    </div>
    <div class="row mt-2" v-if="isDepartureSchool && isFromAee">
      <div class="col-md-2 col-lg-2 col-sm-12">
        <CustomInput
          :value="model.departure.schoolName"
          label="Centro AEE:"
          :disabled="true"
        />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider v-slot="{ errors }" name="place" rules="required">
          <CustomDropDown
            v-model="selectedOptionPlace"
            :options="placeList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Lugar:'"
            :disabled="transportDisabled || isEducationalService"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onPlaceChange"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placeDirection"
          rules="required"
        >
          <CustomInput
            v-model="model.place.addressLine1"
            label="Dirección:"
            :disabled="transportDisabled || disabledPlace"
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <CustomInput
          v-model="model.place.addressLine2"
          label="Dirección 2:"
          :disabled="transportDisabled || disabledPlace"
        />
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placeMunicipality"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedPlaceMunicipality"
            :options="municipalityList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Municipio:'"
            :disabled="transportDisabled || disabledPlaceMunicipality"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onPlaceMunicipalityChange"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-1 col-lg-1 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placeZipcode"
          rules="required"
        >
          <CustomInput
            v-model="model.place.zipCode"
            label="Zipcode:"
            maxlength="5"
            mask-type="Zipcode"
            placeholder="#####"
            :disabled="transportDisabled || disabledPlace"
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-1 col-lg-1 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placeEstate"
          rules="required"
        >
          <CustomInput
            v-model="model.place.state"
            label="Estado:"
            :disabled="transportDisabled || disabledPlace"
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placePhone"
          rules="required"
        >
          <CustomInput
            v-model="model.place.phone"
            label="Tel.:"
            :disabled="transportDisabled || disabledPlace"
            :mask-type="'Phone'"
            placeholder="(787) ###-####"
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
    </div>
    <div class="row mt-2" v-if="isPlaceSchool && isFromAee">
      <div class="col-md-2 col-lg-2 col-sm-12">
        <CustomInput
          :value="model.place.schoolName"
          label="Centro AEE:"
          :disabled="true"
        />
      </div>
    </div>
    <div class="col-12 mt-4">
      <ValidationProvider
        v-slot="{ errors }"
        name="Justificacion"
        rules="required"
      >
        <CustomTextArea
          v-model="model.justification"
          :label="'Justificación:'"
          :placeholder="'Escribe algo...'"
          :error="errors[0]"
          :custom-error-msg="
            errors ? 'Favor de escribir la justificación.' : ''
          "
          :rows="4"
          :maxlength="3000"
          :disabled="transportDisabled"
        />
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import {
  CustomDropDown,
  CustomTextArea,
  CustomInput,
} from '@/components/common';
import { ValidationProvider } from 'vee-validate';
import TransportationOptions from '@/components/pei/service/components/transport-detail/TransportationOptions.vue';
import locationTypes from '@/utils/constants/LocationTypes';
import PeiAnalysisService from '@/utils/constants/pei/peiAnalysisService';

import store from '@/store/index';
export default {
  name: 'TransportCarrier',
  data() {
    return {
      model: {},
      selectedOptionDeparture: null,
      selectedOptionPlace: null,
      selectedOptionSpecialEquipment: null,
      selectedOptionAcompany: null,
      selectedDepartureMunicipality: null,
      selectedPlaceMunicipality: null,
      justification: '',
      companyList: [
        {
          id: '1',
          name: 'Sí',
        },
        {
          id: '0',
          name: 'No',
        },
      ],
      placeMunicipalityHasChanged: null,
    };
  },
  props: {
    departureList: {
      type: Array,
      default: () => [],
    },
    placeList: {
      type: Array,
      default: () => [],
    },
    specialEquipmentList: {
      type: Array,
      default: () => [],
    },
    transportDisabled: {
      type: Boolean,
      default: () => false,
    },
    disabledDeparture: {
      type: Boolean,
      default: () => false,
    },
    disabledPlace: {
      type: Boolean,
      default: () => false,
    },
    allowedTransportOptions: {
      type: Array,
      default: () => [],
    },
    municipalityList: {
      type: Array,
      default: () => [],
    },
    isFromAee: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => ({
        departureCode: 0,
        placeCode: 0,
        specialEquipmentCode: 0,
        acompanyCode: '',
        mileage: 0,
        startDate: '',
        endDate: '',
        peiAnalysisServiceCode: 0,
        justification: '',
        departure: {
          addressLine1: '',
          addressLine2: '',
          municipalityId: '',
          phone: '',
          state: '',
          zipCode: '',
        },
        place: {
          addressLine1: '',
          addressLine2: '',
          municipalityId: '',
          phone: '',
          state: '',
          zipCode: '',
        },
      }),
    },
  },
  computed: {
    isDepartureSchool() {
      return this.model.departureCode == locationTypes.Escuela;
    },
    isPlaceSchool() {
      return this.model.placeCode == locationTypes.Escuela;
    },
    isEducationalService() {
      return this.model.serviceType == PeiAnalysisService.Educativo;
    },
    disabledPlaceMunicipality() {
      const hasPlaceMunicipality =
        this.selectedPlaceMunicipality?.id > 0 &&
        this.placeMunicipalityHasChanged !== true;
      const isPlaceSchool = this.model.placeCode == locationTypes.Escuela;
      // if is a PS and is in draft and the place municipality doesnt have value saved yet,
      // then allow the user to change this field.
      // otherwise disable it
      return this.isPS && !this.transportDisabled && isPlaceSchool
        ? hasPlaceMunicipality
        : this.disabledPlace;
    },
    isPS() {
      return store.getters.getIsPs;
    },
  },
  methods: {
    onOptionChange(item) {
      this.$emit('onTransportTypeChange', item.id);
    },
    onDepartureMunicipalityChange() {
      this.model.departure.municipalityId = this.selectedDepartureMunicipality?.id;
    },
    onPlaceMunicipalityChange() {
      this.model.place.municipalityId = this.selectedPlaceMunicipality?.id;
      this.placeMunicipalityHasChanged = true;
    },
    onSpecialEquipmentChange() {
      this.model.specialEquipmentCode = this.selectedOptionSpecialEquipment.id;
    },
    onDepartureChange() {
      // avoid changing the departure code if it is the same as the selected option
      if (
        this.model.departureCode === this.selectedOptionDeparture?.id &&
        this.selectedOptionDeparture?.id > 0
      ) {
        return;
      }
      this.model.departureCode = this.selectedOptionDeparture?.id;

      if (this.disabledDeparture) {
        this.model.departure = this.clearDirection();
        this.selectedDepartureMunicipality = null;
      }
    },
    onPlaceChange() {
      if (
        this.model.placeCode === this.selectedOptionPlace?.id &&
        this.selectedOptionPlace?.id > 0
      ) {
        return;
      }

      this.model.placeCode = this.selectedOptionPlace?.id;

      if (this.disabledPlace || locationTypes.Oficina_del_Proveedor) {
        this.model.place = this.clearDirection();
        this.selectedPlaceMunicipality = null;
      }
    },
    clearDirection() {
      return {
        addressLine1: '',
        addressLine2: '',
        municipalityId: '',
        phone: '',
        state: '',
        zipCode: '',
        schoolName: '',
        serviceAeeSchoolId: null,
      };
    },
    setMunicipality(municipalityId, municipalityKey) {
      if (this.municipalityList.length === 0) return;

      if (municipalityId && municipalityId > 0)
        this[municipalityKey] = this.municipalityList.find(
          (x) => x.id === municipalityId
        );
    },
    onCompanyChange() {
      this.model.acompanyCode = this.selectedOptionAcompany.id;
    },
  },
  created() {
    this.model = this.value;
  },
  mounted() {
    let transInfo = store.getters.getPeiTransportationInfo;

    if (transInfo.departureCode != null && transInfo.placeCode != null) {
      this.selectedOptionDeparture = this.departureList.find(
        (item) => item.id == transInfo.departureCode
      );
      this.selectedOptionPlace = this.placeList.find(
        (item) => item.id == transInfo.placeCode
      );
      this.selectedOptionAcompany = this.companyList.find(
        (item) => item.id == transInfo.acompanyCode
      );
      this.selectedOptionSpecialEquipment = this.specialEquipmentList.find(
        (item) => item.id == transInfo.specialEquipmentCode
      );
    } else {
      this.selectedOptionDeparture = this.departureList.find(
        (item) => item.id == locationTypes.Hogar
      );
      this.selectedOptionPlace = this.placeList.find(
        (item) => item.id == locationTypes.Escuela
      );
      this.model.departureCode = this.selectedOptionDeparture.id;
      this.model.placeCode = this.selectedOptionPlace.id;
    }
  },
  watch: {
    'model.departure.municipalityId'(value) {
      this.setMunicipality(value, 'selectedDepartureMunicipality');
    },
    'model.place.municipalityId'(value) {
      this.setMunicipality(value, 'selectedPlaceMunicipality');
    },
    municipalityList(value) {
      if (value && value.length > 0) {
        const depatureMunicipalityId = this.model.departure.municipalityId;
        const placeMunicipalityId = this.model.place.municipalityId;

        if (depatureMunicipalityId > 0)
          this.setMunicipality(
            depatureMunicipalityId,
            'selectedDepartureMunicipality'
          );
        if (placeMunicipalityId > 0)
          this.setMunicipality(
            placeMunicipalityId,
            'selectedPlaceMunicipality'
          );
      }
    },
  },
  components: {
    CustomDropDown,
    CustomTextArea,
    ValidationProvider,
    TransportationOptions,
    CustomInput,
  },
};
</script>
